module.exports = __webpack_public_path__ + "static/media/timelapse_17.36b1a083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_17.jpg
// module id = 975
// module chunks = 0